import { cn } from "@/lib/utils"
import { FieldValues, FormProvider } from "react-hook-form"

import { UseFormReturn } from "react-hook-form"

interface FormProps<T extends FieldValues> {
  form: UseFormReturn<T>
  children: React.ReactNode
  onSubmit: (values: T) => void
  className?: string
}

function Form(props: FormProps<any>) {
  return (
    <FormProvider {...props.form}>
      <form onSubmit={props.form.handleSubmit(props.onSubmit)} className={cn("flex flex-col gap-4 w-full", props.className)}>
        {props.children}
      </form>
    </FormProvider>
  )
}

export default Form
